import { eventsMapped } from '../../utils/behaviors_translate';
import { getFieldAPI, getFormElementAPI } from '../../utils/form_element_api_builder';

let behaviorsEventsSubscriptions = [];

export const subscribe = (formAPI, eventHandler) => {
	const formBehaviors = formAPI.behaviors();
	unsubscribeFromPreviousBehaviorsEvents();
	formBehaviors.forEach(subscribeToBehaviorEvents.bind(this, formAPI, eventHandler));
};

const unsubscribeFromPreviousBehaviorsEvents = () => {
	behaviorsEventsSubscriptions.forEach((s) => s.unsubscribe());
};

const subscribeToBehaviorEvents = (formAPI, eventHandler, behavior) => {
	const { events } = behavior;
	const eventsEnabled = (events || []).filter(e => e.enabled);
	if (Array.isArray(eventsEnabled) && eventsEnabled.length > 0) {
		eventsEnabled.forEach(event => {
			const eventFind = eventsMapped.find(e => e.eventType === event.event_type);
			let action_alias = event.action_alias;

			const isRefreshButtonEvent = event.event_type === 'ACTION_CLICK' && event.field_id;
			const isApplicationButtonEvent = event.event_type === 'FIELD_CLICK' && event.field_id && event.action_alias;

			if (isRefreshButtonEvent) {
				const fieldApi = getFieldAPI(formAPI, { fieldId: isRefreshButtonEvent });
				action_alias = fieldApi ? `${fieldApi.id}_refresh` : '';
			}

			subscribeBehaviorToEvent(formAPI, eventHandler, behavior, {
				...event,
				event: eventFind.property,
				element: isApplicationButtonEvent ? "ACTION" : eventFind.element,
				fieldId: event.field_id,
				gridId: event.grid_alias,
				actionId: action_alias
			})
		});
	}
};

const subscribeBehaviorToEvent = (formAPI, eventHandler, behavior, behaviorEvent) => {
	const behaviorElementAPI = getBehaviorElementAPI(formAPI, behaviorEvent);
	const eventName = behaviorEvent.event;
	if(behaviorElementAPI){
		behaviorsEventsSubscriptions.push(
			behaviorElementAPI.subscribe(eventName, eventHandler.bind(this, formAPI, behavior, behaviorEvent))
		);
	}
};

const getBehaviorElementAPI = (formAPI, behaviorEvent) => {
	const behaviorElementAPI = getFormElementAPI(formAPI, behaviorEvent);
	return behaviorElementAPI;
};

export default {
	subscribe,
};
